interface IFoundMap<T> {
    [index: number]: T;
    values: T[];
}

/**
 * Similar to `findIndex`, but returns the indices and values of all items matching the condition in
 * provided the callback function.
 *
 * For flexibility, it returns findings as both a hash-map like structure with matching indices as
 * keys (for 0(1) lookup of indices), *and* as and an array of `values` that can be iterated over.
 */

const findIndices = <T = any>(arr: T[], cb: (item: T) => boolean): IFoundMap<T> => {
    const found: IFoundMap<T> = {
        values: [],
    };

    for (let i = 0; i < arr.length; i++) {
        const item = arr[i];

        if (cb(item)) {
            found[i] = item;
            found.values.push(item);
        }
    }

    return found;
};

export default findIndices;
